export const NAVIGATION_CONSTANTS = {
    ANONYMOUS_ASSET_ID : "id"
}